"use strict";
exports.__esModule = true;
var errorHandler = function (error) {
    if (error instanceof Error) {
        return Promise.reject(error);
    }
    return Promise.reject(new Error(JSON.stringify(error)));
};
exports["default"] = errorHandler;
